<template>
  <el-card class="h-full relative">
    <div class="w-full h-full flex">
      <div class="w-287px mr-38px warp-border px-4px pt-15px pb-4px">
        <div class="flex">
          <el-input size="small" v-model="keywords" placeholder="姓名/部门" />
          <el-button type="primary" @click="searchList">查询</el-button>
        </div>
        <el-table
          :data="equipDataList"
          border
          class="w-full mt-15px"
          :height="tableHeight"
          stripe
          @row-click="changeCourse"
          :cell-style="getCurrentTr"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="姓名"
            prop="examineeName"
            width="70"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="所属部门" prop="department">
            <template slot-scope="scope">
              <div class="flex items-center">
                <p :title="scope.row.department" class="mr-10px over-text">
                  {{ scope.row.department }}
                </p>
                <p class="mark" :class="scope.row.markingPaper ? 'mark_blue' : 'mark_red'">
                  {{ scope.row.markingPaper ? '已阅' : '未阅' }}
                </p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="w-287px relative mr-38px   pb-4px ">
        <div class="warp-border px-15px overflow-y-auto h-full" style="height:calc( 100% - 20px )">
          <div class="text-14px">
            <div class="font-600 leading-32px ">考试信息</div>
            <div class="px-10px leading-30px ">
              <div>考生姓名：{{ currentExaminee.examineeName }}</div>
              <div>考生编号：{{ currentExaminee.examineeCode }}</div>
              <div>考试时间：{{ currentExaminee | showTime }}</div>
            </div>
          </div>
          <div class="text-14px">
            <div class="font-600 leading-32px ">打分情况</div>
            <div class="px-10px leading-30px">
              <div v-for="(item, index) in renderData" :key="index">
                <div v-if="[0, 1, 2].includes(item.questionType)">
                  <div class="flex justify-between">
                    <p>{{ chartperIndex[index] + typeTopicList[item.questionType] }}题</p>
                    <p class="deserve-score">{{ item.questionType | showText(renderData) }}</p>
                  </div>
                  <div
                    class="content pl-10px"
                    v-for="(topic, order) in item.topicContents"
                    :key="order"
                  >
                    <div class="flex justify-between items-center">
                      <p>第{{ order + 1 }}题</p>
                      <p class="w-60px text-center">
                        <i
                          v-if="topic.examineeAnswerContent === topic.correct"
                          class="el-icon-circle-check text-18px"
                          style="color:#00ff0d"
                        />
                        <i v-else class="el-icon-circle-close text-18px text-red-500"></i>
                      </p>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="flex justify-between">
                    <p>{{ chartperIndex[index] + typeTopicList[item.questionType] }}题</p>
                    <p class="deserve-score">{{ item.questionType | showText(renderData) }}</p>
                  </div>
                  <div
                    class="content pl-10px"
                    v-for="(topic, order) in item.topicContents"
                    :key="order"
                  >
                    <div class="flex justify-between items-center">
                      <p>第{{ order + 1 }}题</p>
                      <span>
                        <p class="deserve-score">{{ topic.examineeScore }}分</p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="absolute bottom-0px left-0px h-20px w-full summary-score flex justify-between"
          >
            <p>
              汇总分数：<span>{{ currentContent.paperTotalScore }}分</span>
            </p>
          </div>
        </div>
      </div>
      <div class="flex-1 warp-border">
        <PaperCom
          :renderData.sync="renderData"
          :currentContent="currentContent"
          :originData="originData"
          :isAbled="true"
          @updateScore="updateScore"
          @goSave="goSave"
        />
      </div>
    </div>
  </el-card>
</template>

<script>
import { ReadExamPaperApi } from '@wiz-api/exam-management'
import dayjs from 'dayjs'
import PaperCom from './PaperCom'

const readExamPaperApi = new ReadExamPaperApi()

export default {
  name: 'paper-score',
  components: { PaperCom },
  data() {
    return {
      equipDataList: [],
      typeTopicList: ['单选', '多选', '判断', '填空', '简答'],
      chartperIndex: ['一、', '二、', '三、', '四、', '五、'],
      keywords: '',
      currentExaminee: {},
      currentIndex: 0,
      currentContent: {},
      renderData: [],
      textContentId: '',
      totalScore: 0,
      originData: {},
    }
  },
  filters: {
    showText: (val, type) => {
      const data = type.find((item) => {
        return val === item.questionType
      })
      const res = data?.score || 0
      return `${res}分`
    },
    showTime: (val) => {
      if (!val.singleExamStartTime) return ''
      const time = `${dayjs(val.singleExamStartTime).format('YYYY-MM-DD HH:mm:ss')}-${dayjs(
        val.singleExamEndTime
      ).format('YYYY-MM-DD HH:mm:ss')}`
      return time
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 52px)'
    },
  },
  methods: {
    // 切换学生
    async changeCourse(row) {
      this.currentExaminee = row
      const data = {
        examAnswerId: row.examAnswerId,
        examinee: row.examinee,
      }
      const [err, res] = await readExamPaperApi.getExamContent(data)
      if (!err) {
        const examEndTime = res.content.examEndTime
        const examStartTime = res.content.examStartTime
        res.content.examStartTime =
          examStartTime && dayjs(examStartTime).format('YYYY-MM-DD HH:mm:ss')
        res.content.examEndTime = examEndTime && dayjs(examEndTime).format('YYYY-MM-DD HH:mm:ss')

        this.textContentId = res.textContentId
        this.currentContent = res.content

        this.renderData = res.content.topicTypes.filter((item) => item.topicContents.length)
        this.renderData = this.renderData.map((item) => {
          if (item.questionType != 1) {
            return item
          }
          item.topicContents = item.topicContents.map((content) => {
            if (content.examineeAnswerContent) {
              // 处理历史数据
              content.examineeAnswerContent = content.examineeAnswerContent
                .split(',')
                .sort()
                .join(',')
            }
            return content
          })
          return item
        })
        this.originData = res
        this.updateScore()
      }
    },
    // 当前学生
    getCurrentTr({ row }) {
      if (row.id === this.currentExaminee.id) {
        return { backgroundColor: '#99c6e8' }
      }
      return ''
    },
    // 学生列表
    async searchList() {
      const data = {
        keywords: this.keywords,
        examSessionId: this.$route.query.id,
      }
      const [err, res] = await readExamPaperApi.getExaminees(data)
      if (!err) {
        this.equipDataList = res
        if (!res.length) return
        let last
        this.equipDataList.forEach((item) => {
          if (item.lastModificationTime) {
            if (!last) {
              last = item
            } else {
              last =
                new Date(item.lastModificationTime).getTime() >
                new Date(last.lastModificationTime).getTime()
                  ? item
                  : last
            }
          }
        })
        last = last || this.equipDataList[0]
        this.changeCourse(last)
      }
    },
    // 更新分数
    updateScore() {
      this.currentContent.paperTotalScore = 0
      this.totalScore = 0
      this.renderData.forEach((item) => {
        item.score = 0
        item.topicContents.forEach((val) => {
          if (item.questionType == 1 && !val.examineeAnswerContent) {
            return
          } else if (item.questionType == 1 && val.examineeAnswerContent) {
            // 多选题
            if (val.examineeAnswerContent != val.correct) {
              return
            } else {
              item.score += val.score
              return
            }
          }
          item.score += val.examineeScore
        })
        this.currentContent.paperTotalScore += item.score
      })
    },
    // 提交
    async goSave() {
      const params = {
        readRecordId: this.originData.readRecordId,
        textContentId: this.textContentId,
        totalScore: this.currentContent.paperTotalScore,
        examAnswerId: this.currentExaminee.examAnswerId,
      }
      params.content = this.currentContent
      const [err, res] = await readExamPaperApi.readPapaer({ body: params })
      if (err) return
      this.searchList()
      this.$message.success('阅卷成功')
    },
  },
  mounted() {
    this.searchList()
  },
}
</script>

<style lang="scss" scoped>
.over-text {
  width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mark_blue {
  width: 44px;
  height: 24px;
  border: 1px solid #0099ff;
  text-align: center;
  border-radius: 50%;
  color: #0099ff;
  font-size: 12px;
}
.mark_red {
  width: 44px;
  height: 24px;
  border: 1px solid #ef0000;
  text-align: center;
  border-radius: 50%;
  color: #ef0000;
  font-size: 12px;
}
::v-deep .el-card__body {
  height: 100%;
}
.warp-border {
  border: 1px solid #d9d9d9;
  .deserve-score {
    width: 66px;
    height: 25px;
    line-height: 25px;
    color: red;
    background-color: #d9d9d9;
    text-align: center;
  }
}
.title-wrap {
  border-bottom: 1px solid #d9d9d9;
  font-size: 13px;
}
.summary-score {
  background-color: #d9d9d9;
  font-size: 12px;
  line-height: 20px;
  padding-left: 20px;
}
</style>
